import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Sparkles } from 'lucide-react';
import { trackEvent } from '../hooks/useMetaPixel';
export function HeroSection() {
  return <section className="relative min-h-[90vh] flex items-center justify-center pt-20 pb-16 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-[#0d0b14] via-slate-950 to-[#0d0b14] overflow-hidden" data-id="element-53">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-54">
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] rounded-full bg-pink-500/20 blur-3xl" data-id="element-55" />
        <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] rounded-full bg-purple-500/20 blur-3xl" data-id="element-56" />
      </div>

      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center relative z-10" data-id="element-57">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="text-center lg:text-left" data-id="element-58">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-pink-500/20 text-pink-300 border border-pink-500/30 font-medium text-sm mb-6" data-id="element-59">
            <Sparkles className="w-4 h-4" data-id="element-60" />
            <span data-id="element-61">Transforma tu vida hoy</span>
          </div>

          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white leading-tight mb-6" data-id="element-62">
            Vuelve a brillar, reprograma tu mente y aprende a crear{' '}
            <span className="text-gradient" data-id="element-63">nuevas oportunidades</span> con
            inteligencia artificial.
          </h1>

          <p className="text-lg sm:text-xl text-slate-300 mb-8 max-w-2xl mx-auto lg:mx-0" data-id="element-64">
            Este sistema te ayudará a trabajar tu mentalidad, crear hábitos
            poderosos y aprender a usar herramientas de inteligencia artificial
            para transformar tus ideas en nuevas oportunidades de crecimiento
            personal y económico.
          </p>

          <motion.a href="#offer" onClick={(e: React.MouseEvent) => {
          e.preventDefault();
          document.getElementById('offer')?.scrollIntoView({
            behavior: 'smooth'
          });
        }} whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="inline-block w-full sm:w-auto px-8 py-4 bg-gradient-primary text-white rounded-full font-bold text-lg shadow-xl shadow-pink-500/40 hover:shadow-pink-500/60 transition-all text-center cursor-pointer" data-id="element-65">
            QUIERO EMPEZAR HOY
          </motion.a>

          <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center lg:justify-start text-sm text-slate-300 font-medium" data-id="element-66">
            <div className="flex items-center gap-2" data-id="element-67">
              <CheckCircle2 className="w-5 h-5 text-pink-400" data-id="element-68" />
              <span data-id="element-69">Trabaja tu mentalidad y hábitos</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-70">
              <CheckCircle2 className="w-5 h-5 text-pink-400" data-id="element-71" />
              <span data-id="element-72">Aprende a usar inteligencia artificial</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-73">
              <CheckCircle2 className="w-5 h-5 text-pink-400" data-id="element-74" />
              <span data-id="element-75">Diseñado para empezar desde cero</span>
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative mx-auto w-full max-w-md lg:max-w-full" data-id="element-76">
          <div className="relative z-10 drop-shadow-2xl transform hover:-translate-y-2 transition-transform duration-500" data-id="element-77">
            <img src="https://cdn.magicpatterns.com/uploads/fcAQbBRNn7jqdihi6osJT9/091cdbc8-f8ed-4946-bf55-0ffac9610552_-_Editado_(1).png" alt="Kit Vuelve a Brillar con IA" className="w-full h-auto object-contain" data-id="element-78" />
          </div>
          {/* Decorative glow behind image */}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[80%] h-[80%] bg-gradient-to-tr from-pink-500 to-purple-500 rounded-full blur-3xl opacity-40 -z-10" data-id="element-79" />
        </motion.div>
      </div>
    </section>;
}